import { Component, OnInit, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { IOTPdata, IPhoneNumber, IRegisterMidwife, IRegisterMidWifeResponse, IRegisterMum, IRegisterMumResponse } from 'src/app/models/auth.models';
import { AuthService } from 'src/app/services/auth.service';
import { errorMessages, userType } from 'src/app/constants/global-constants';
import * as moment from 'moment';
import { HttpErrorResponse } from '@angular/common/http';
import { IGenericResponse } from 'src/app/models/shared.models';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { HomeService } from 'src/app/services/home.service';
import { IConfigurationResponse, IPlace, IService } from 'src/app/models/dashboard.models';
import { countryCodes } from 'src/app/constants/country';
import { environment } from 'src/environments/environment';
import { FormControl, Validators } from '@angular/forms';
declare var $: any;
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import { EditProfileService } from 'src/app/services/edit-profile.service';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent implements OnInit {

  eye1 = true;
  eye2 = true;
  @ViewChild('PassPregnant') passPregnant: ElementRef;
  @ViewChild('PassMidwife') passMidwife: ElementRef;
  ethnicities: Array<string> = [];
  areas: IService[] = [];
  subAreas: IService[] = [];
  selectedArea: IService;
  @Output() otpVerfication = new EventEmitter();
  @ViewChild('selectLanguage') selectLanguage: MatSelect;
  @ViewChild('selectAreas') selectAreas: MatSelect;
  @ViewChild('selectSpecialized') selectSpecialized: MatSelect;

  specialities: Array<string> = [];
  languages: Array<string> = [];
  services: Array<string> = [];
  experiences: Array<number> = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  serviceAreas = {
    speciality : [] as any
  };

  selectedLanguages: Array<string> = [];

  countries = countryCodes.countries;

  registerMumForm: IRegisterMum = {
    address: '',
    age: 0,
    area: '',
    dueDate: '',
    name: '',
    device: '',
    userEmail: '',
    userHashPassword: '',
    userPhonenumber: '',
    countryCode: '+64',
    surname: ''
  };

  // @ts-ignore
  registerMidWifeForm: {
    address: string;
    languages: string;
    ethnicity: string;
    experienceInYears: number;
    practiceId: string;
    alternatePhonenumber: string;
    speciality: string;
    userPhonenumber: string;
    userHashPassword: string;
    countryCode: string;
    name: string;
    userEmail: string;
    device: string;
    serviceAreas: string;
    surname: string;
  } = {
    address: '',
    experienceInYears: 0,
    languages: '',
    practiceId: '',
    speciality: '',
    serviceAreas: '',
    name: '',
    device: '',
    ethnicity: '',
    userEmail: '',
    userHashPassword: '',
    userPhonenumber: '',
    countryCode: '+64',
    alternatePhonenumber: '',
    surname: '',
  };
  registeredMidwife = true;
  loading = false;
  minDate = new Date().getFullYear();
  emailOtp = false;
  phoneOtp = false;
  userType = userType;

  regMumResponse: IRegisterMumResponse;
  otpData: IOTPdata = {
    userEmail: '',
    userPhonenumber: '',
    userHashPassword: '',
    userType: ''
  };

  errorMessage = '';
  submitMom = false;
  submitMidwife = false;

  myControl = new FormControl('', Validators.required);
  options: string[] = [];
  filteredOptions: Observable<string[]>;

  allSelectedLanguage = false;
  allSelectedAreas = false;
  allSelectedSpecialized = false;

  constructor(private authService: AuthService,
              private homeService: HomeService,
              private snackbar: SnackbarService,
              private editProfileService: EditProfileService) { }

  ngOnInit(): void {
    this.getDropdownConfigurations();
    this.countries.forEach(country => {
      country.flag = environment.countryFlagUrl + country.code.toLowerCase() + '.svg';
    });

    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => this.searchPlace(value)),
    );
  }
selectAreaMum(value: any){
    this.registerMumForm.address = value;
  }

  selectAreaMidwife(value: any){
    this.registerMidWifeForm.address = value;
  }

  searchPlace(searchText: string): Array<string>{
    let body = {
      searchText
    };
    this.registerMumForm.address = '';
    this.registerMidWifeForm.address = '';
    this.options = [];
    let sample: Array<string> = [];
    this.editProfileService.getPlaceSearchResults(body)
    .subscribe((res: Array<IPlace>) => {
      console.log('Search Places:', res);
      res.forEach(place => { sample.push(place.description); });
    }, err => {
      console.error('Search Places Error:', err);
    });
    this.options = sample;
    return this.options;
  }

  navigateToLogin(){
    this.resetMumForm();
    this.resetMidWifeForm();
    $('#signup-modal-midwife-1').modal('hide');
    $('#signup-modal-midwife-2').modal('hide');
    $('#signup-modal-pregnant').modal('hide');
    $('#login-modal').modal('show');
  }

  verifyAccount(){
    $('#signup-modal-midwife-2').modal('hide');
    $('#signup-modal-pregnant').modal('hide');
    $('#verify-email-mobile-modal').modal('show');
  }

  nextSignupMidwife(){
    $('#signup-modal-midwife-1').modal('hide');
    $('#signup-modal-midwife-2').modal('show');
  }

  previousSignupMidwife(){
    $('#signup-modal-midwife-2').modal('hide');
    $('#signup-modal-midwife-1').modal('show');
  }


  toggle(option: string) {
    if (option == 'pregnant')
    {
      this.eye1 = !this.eye1;
      this.passPregnant.nativeElement.type = this.eye1 ? 'password' : 'text';
    }
    else{
      this.eye2 = !this.eye2;
      this.passMidwife.nativeElement.type = this.eye2 ? 'password' : 'text';
    }
  }

  keyPressNumbersDecimal(event: any) {
    let charCode = (event.which) ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  // tslint:disable-next-line:typedef
  keyPressAlphaNumeric(event: any) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode >= 48 && charCode <= 57) || (charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122)
    || charCode === 43 ) {
      return true;
    }
    else{
      event.preventDefault();
      return false;
    }
  }

  // tslint:disable-next-line:typedef
  register(type: string){
    this.registerMumForm.dueDate = moment(this.registerMumForm.dueDate).format('YYYY-MM-DD');
    if (this.authService.isUserTypeMum(type)){
      this.otpData.userHashPassword = this.registerMidWifeForm.userHashPassword;
      this.otpData.userType = userType.MUM;
      this.registerMumForm.countryCode = this.registerMumForm.countryCode.slice(1);
      this.submitMom = true;
      this.registerMum();
    }
    else{
      this.otpData.userHashPassword = this.registerMumForm.userHashPassword;
      this.otpData.userType = userType.MIDWIFE;
      this.registerMidWifeForm.languages = String(this.selectLanguage.value[0] == 0 ? this.selectLanguage.value.slice(1) : this.selectLanguage.value);
      this.registerMidWifeForm.speciality = String(this.serviceAreas.speciality[0] == 0 ? this.serviceAreas.speciality.slice(1) : this.serviceAreas.speciality);
      this.registerMidWifeForm.serviceAreas = String(this.services[0] == '0' ? this.services.slice(1) : this.services);
      this.registerMidWifeForm.experienceInYears = Number(this.registerMidWifeForm.experienceInYears);
      this.registerMidWifeForm.countryCode = this.registerMidWifeForm.countryCode.slice(1);
      this.submitMidwife = true;
      this.registerMidwife();
    }
  }

  registerMum(){
    console.log('Register Mum data : ', this.registerMumForm);
    localStorage.setItem('signupUser', this.registerMumForm.userHashPassword);
    this.authService.registerMum(this.registerMumForm)
    .subscribe(
      (res: IRegisterMumResponse) => {
        console.log('Register Mum API ', res);
        this.sendPhoneOTP(userType.MUM);
      },
      (err: HttpErrorResponse) => {
        console.error('Register Mum API Error', err);
        this.submitMom = false;
        this.snackbar.openSnackBar(this.getErrorMessage(err.error.errorMessage));
      }
    );
  }

  registerMidwife(){
    console.log('Register Midwife data : ', this.registerMidWifeForm);
    localStorage.setItem('signupUser', this.registerMidWifeForm.userHashPassword);
    this.authService.registerMidwife(this.registerMidWifeForm)
    .subscribe(
      (res: IRegisterMidWifeResponse) => {
        console.log('Register Midwife API ', res);
        this.sendPhoneOTP(userType.MIDWIFE);
      },
      (err: HttpErrorResponse) => {
        console.error('Register Midwife API Error', err);
        this.submitMidwife = false;
        this.snackbar.openSnackBar(this.getErrorMessage(err.error.errorMessage));
      }
    );
  }

  sendPhoneOTP(type: string){
    let data: any = {
      userType: type
    };
    if (this.authService.isUserTypeMum(type)){
      data.userPhonenumber = this.registerMumForm.userPhonenumber;
    }
    else{
      data.userPhonenumber = this.registerMidWifeForm.userPhonenumber;
    }
    console.log('Phone OTP Input ', data);

    this.authService.requestOtpPhone(data)
    .subscribe(
      (res: IGenericResponse) => {
        console.log('Phone OTP Sent :', res);
        this.sendEmailOTP(type);
      },
      (err: HttpErrorResponse) => {
        console.error(' Phone OTP API error :', err);
        this.submitMom = true;
        this.submitMidwife = false;
        this.snackbar.openSnackBar(this.getErrorMessage(err.error.errorMessage));
      }
    );
  }

  sendEmailOTP(type: string){
    let data: any = {
      userType: type
    };
    if (this.authService.isUserTypeMum(type)){
      data.userEmail = this.registerMumForm.userEmail;
    }
    else{
      data.userEmail = this.registerMidWifeForm.userEmail;
    }
    this.otpData.userEmail = data.userEmail;

    this.authService.requestOtpEmail(data)
    .subscribe(
      (res: IGenericResponse) => {
        console.log('Email OTP Sent :', res);
        this.otpVerfication.emit(this.otpData);
        this.submitMidwife = false;
        this.submitMom = false;
        this.verifyAccount();
      },
      (err: HttpErrorResponse) => {
        console.error(' Email OTP API error :', err);
        this.submitMom = false;
        this.submitMidwife = false;
        this.snackbar.openSnackBar(this.getErrorMessage(err.error.errorMessage));
      }
    );
  }

  onDatePickerClick(){
    $('#due-date-picker').click();
  }

  setRegisteredMidwife(event: any){
    if (event.target.value == 'yes'){
      this.registeredMidwife = true;
    }
    else{
      this.registeredMidwife = false;
    }
    console.log('Event ', event);
  }

  // tslint:disable-next-line:typedef
  resetMumForm(){
    this.registerMumForm = {
      surname: '',
      address: '',
      age: 0,
      area: '',
      dueDate: '',
      name: '',
      device: '',
      userEmail: '',
      userHashPassword: '',
      userPhonenumber: '',
      countryCode: '+64'
    };
    this.myControl.reset();
  }

  // tslint:disable-next-line:typedef
  resetMidWifeForm(){
    // @ts-ignore
    // @ts-ignore
    this.registerMidWifeForm = {
      address: '',
      experienceInYears: 0,
      languages: '',
      practiceId: '',
      speciality: '',
      serviceAreas: '',
      name: '',
      device: '',
      ethnicity: '',
      userEmail: '',
      userHashPassword: '',
      userPhonenumber: '',
      alternatePhonenumber: '',
      countryCode: '+64',
      surname : ''
    },
    this.selectedLanguages = [];
    this.services = [];
    this.serviceAreas.speciality = [];
  }

  getErrorMessage(errorMessage?: string){
    if (errorMessage){
      return errorMessage;
    }
    return errorMessages.SOMETHING_WENT_WRONG;
  }

  getDropdownConfigurations(): void{
    this.ethnicities = [];
    this.specialities = [];
    this.languages = [];
    this.areas = [];
    this.subAreas = [];
    this.homeService.getMiscConfiguration()
    .subscribe((res: IConfigurationResponse) => {
      res.payload.ethnicities.forEach(ethnicitie => this.ethnicities.push(ethnicitie.name));
      res.payload.specialities.forEach(specialitie => this.specialities.push(specialitie.name));
      res.payload.languages.forEach(language => this.languages.push(language.name));
      this.areas = res.payload.serviceAreas;
      this.areas.forEach(area => {
        this.subAreas = this.subAreas.concat(area.childAreas);
      });
    }, err => {
      console.error('Dropdown detail Error:', err);
    });
  }

  closeDropdown(){
    this.selectLanguage.close();
    this.selectAreas.close();
    this.selectSpecialized.close();
  }

  toggleAllSelection(type: string) {
    if (type == 'Language'){
      this.allSelectedLanguage = !this.allSelectedLanguage;
      if (this.allSelectedLanguage) {
        this.selectLanguage.options.forEach( (item: MatOption) => item.select());
      } else {
        this.selectLanguage.options.forEach( (item: MatOption) => {item.deselect(); });
      }
    }
    else if (type == 'Area'){
      this.allSelectedAreas = !this.allSelectedAreas;
      if (this.allSelectedAreas) {
        this.selectAreas.options.forEach( (item: MatOption) => item.select());
      } else {
        this.selectAreas.options.forEach( (item: MatOption) => {item.deselect(); });
      }
    }
    else if (type === 'Specialized'){
      this.allSelectedSpecialized = !this.allSelectedSpecialized;
      if (this.allSelectedSpecialized) {
        this.selectSpecialized.options.forEach( (item: MatOption) => item.select());
      } else {
        this.selectSpecialized.options.forEach( (item: MatOption) => {item.deselect(); });
      }
    }
  }
}
